import { z, ZodIssueCode } from "zod";

import { AddressObjectInputSchema, RoomI18nInputSchema } from "@/lib/zod/__generated__/validation-schema";

import { postalCodeZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

import type { ZodError } from "zod";

export const roomI18nInputZodSchema = RoomI18nInputSchema.extend({
	name: z.string().min(1).max(150),
	catchCopy: z.string().max(100),

	address: AddressObjectInputSchema.extend({
		postalCode: postalCodeZodSchema.nullish(),
		pref: z.string().max(100).nullish(),
		city: z.string().max(300).nullish(),
		town: z.string().max(300).nullish(),
	})
		.nullish()
		.superRefine((data, ctx) => {
			const { postalCode, pref, city, town } = data ?? {};

			if (!postalCode && !pref && !city && !town) {
				return z.NEVER;
			}

			if (!pref) {
				ctx.addIssue({
					code: ZodIssueCode.custom,
					message: "都道府県を入力してください",
					path: ["pref"],
				});
			}

			if (!city) {
				ctx.addIssue({
					code: ZodIssueCode.custom,
					message: "市区町村を入力してください",
					path: ["city"],
				});
			}

			if (!town) {
				ctx.addIssue({
					code: ZodIssueCode.custom,
					message: "市区町村以降を入力してください",
					path: ["town"],
				});
			}
		}),
});

export type RoomI18nInputZodSchemaType = z.infer<typeof roomI18nInputZodSchema>;

export type RoomI18nInputZodParseErrorType = ZodError<RoomI18nInputZodSchemaType>;
